"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var EVENT_TYPES = {
  CONTACT_INFORMATION_LOADED: 'Contact Information loaded',
  CONTACT_INFORMATION_EDIT_LOADED: 'Contact Information edit loaded'
};
var _default = exports.default = EVENT_TYPES;
//# sourceMappingURL=analytics.js.map